import { InjectionToken } from "@angular/core";
import { WalletTopupRankingsPort } from "./wallet-topup-rankings.port";

export const WALLET_TOPUP_RANKINGS_PORT =
  new InjectionToken<WalletTopupRankingsPort>("WALLET_TOPUP_RANKINGS_PORT");
